/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdpClaimMappingDto } from './IdpClaimMappingDto';
import {
    IdpClaimMappingDtoFromJSON,
    IdpClaimMappingDtoFromJSONTyped,
    IdpClaimMappingDtoToJSON,
    IdpClaimMappingDtoToJSONTyped,
} from './IdpClaimMappingDto';

/**
 * 
 * @export
 * @interface UserManagementConfigurationDto
 */
export interface UserManagementConfigurationDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    defaultRoleEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    defaultRoleId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    defaultRoleName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    notifyAdminOnNewUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    requireAdminApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    remoteTenantDefaultRoleEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    remoteTenantDefaultRoleId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    remoteTenantDefaultRoleName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    autoProvisionRemoteUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    notifyAdminOnRemoteUserProvisioning?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    defaultCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationDto
     */
    defaultUserTimezone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementConfigurationDto
     */
    userExistenceCheckEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserManagementConfigurationDto
     */
    userExistenceCheckIntervalMinutes?: number;
    /**
     * 
     * @type {Array<IdpClaimMappingDto>}
     * @memberof UserManagementConfigurationDto
     */
    idpClaimMappings?: Array<IdpClaimMappingDto>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserManagementConfigurationDto
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the UserManagementConfigurationDto interface.
 */
export function instanceOfUserManagementConfigurationDto(value: object): value is UserManagementConfigurationDto {
    return true;
}

export function UserManagementConfigurationDtoFromJSON(json: any): UserManagementConfigurationDto {
    return UserManagementConfigurationDtoFromJSONTyped(json, false);
}

export function UserManagementConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserManagementConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'defaultRoleEnabled': json['default_role_enabled'] == null ? undefined : json['default_role_enabled'],
        'defaultRoleId': json['default_role_id'] == null ? undefined : json['default_role_id'],
        'defaultRoleName': json['default_role_name'] == null ? undefined : json['default_role_name'],
        'notifyAdminOnNewUser': json['notify_admin_on_new_user'] == null ? undefined : json['notify_admin_on_new_user'],
        'requireAdminApproval': json['require_admin_approval'] == null ? undefined : json['require_admin_approval'],
        'remoteTenantDefaultRoleEnabled': json['remote_tenant_default_role_enabled'] == null ? undefined : json['remote_tenant_default_role_enabled'],
        'remoteTenantDefaultRoleId': json['remote_tenant_default_role_id'] == null ? undefined : json['remote_tenant_default_role_id'],
        'remoteTenantDefaultRoleName': json['remote_tenant_default_role_name'] == null ? undefined : json['remote_tenant_default_role_name'],
        'autoProvisionRemoteUsers': json['auto_provision_remote_users'] == null ? undefined : json['auto_provision_remote_users'],
        'notifyAdminOnRemoteUserProvisioning': json['notify_admin_on_remote_user_provisioning'] == null ? undefined : json['notify_admin_on_remote_user_provisioning'],
        'defaultCountryCode': json['default_country_code'] == null ? undefined : json['default_country_code'],
        'defaultUserTimezone': json['default_user_timezone'] == null ? undefined : json['default_user_timezone'],
        'userExistenceCheckEnabled': json['user_existence_check_enabled'] == null ? undefined : json['user_existence_check_enabled'],
        'userExistenceCheckIntervalMinutes': json['user_existence_check_interval_minutes'] == null ? undefined : json['user_existence_check_interval_minutes'],
        'idpClaimMappings': json['idp_claim_mappings'] == null ? undefined : ((json['idp_claim_mappings'] as Array<any>).map(IdpClaimMappingDtoFromJSON)),
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function UserManagementConfigurationDtoToJSON(json: any): UserManagementConfigurationDto {
    return UserManagementConfigurationDtoToJSONTyped(json, false);
}

export function UserManagementConfigurationDtoToJSONTyped(value?: UserManagementConfigurationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'default_role_enabled': value['defaultRoleEnabled'],
        'default_role_id': value['defaultRoleId'],
        'default_role_name': value['defaultRoleName'],
        'notify_admin_on_new_user': value['notifyAdminOnNewUser'],
        'require_admin_approval': value['requireAdminApproval'],
        'remote_tenant_default_role_enabled': value['remoteTenantDefaultRoleEnabled'],
        'remote_tenant_default_role_id': value['remoteTenantDefaultRoleId'],
        'remote_tenant_default_role_name': value['remoteTenantDefaultRoleName'],
        'auto_provision_remote_users': value['autoProvisionRemoteUsers'],
        'notify_admin_on_remote_user_provisioning': value['notifyAdminOnRemoteUserProvisioning'],
        'default_country_code': value['defaultCountryCode'],
        'default_user_timezone': value['defaultUserTimezone'],
        'user_existence_check_enabled': value['userExistenceCheckEnabled'],
        'user_existence_check_interval_minutes': value['userExistenceCheckIntervalMinutes'],
        'idp_claim_mappings': value['idpClaimMappings'] == null ? undefined : ((value['idpClaimMappings'] as Array<any>).map(IdpClaimMappingDtoToJSON)),
        'metadata': value['metadata'],
    };
}

